"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LinkTab_component_exports = {};
__export(LinkTab_component_exports, {
  LinkTab: () => LinkTab
});
module.exports = __toCommonJS(LinkTab_component_exports);
var import_react = __toESM(require("react"));
var import_useOnKeydown = require("../../../../utils/useOnKeydown/useOnKeydown.hook");
var import_WithTooltip = require("../../../atoms/Tooltip/WithTooltip/WithTooltip.component");
var import_TabListContext = require("../TabListContext");
var import_Tab = require("../Tab/Tab.styled");
var import_LinkTab = require("./LinkTab.styled");
function _objectDestructuringEmpty(t) {
  if (null == t)
    throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var LinkTab = function LinkTab2(_ref) {
  var _props$title;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var linkTabRef = (0, import_react.useRef)(null);
  var _UseTabListContext = (0, import_TabListContext.UseTabListContext)(import_TabListContext.TabListContext, "LinkTab"), selectedTabId = _UseTabListContext.selectedTabId, handleOnSelect = _UseTabListContext.handleOnSelect;
  var selected = props.id === selectedTabId;
  var onClick = function onClick2() {
    if (handleOnSelect && !props.isDisabled) {
      handleOnSelect(props.id, props.title);
    }
  };
  (0, import_useOnKeydown.useOnKeydown)(linkTabRef, function(keyList) {
    if (keyList.Enter && !props.isDisabled) {
      handleOnSelect(props.id, props.title);
    }
  });
  var tabIndexByNavStrategy = {
    browserDefault: 0,
    arrowsHandled: selected ? 0 : -1
  };
  var tabIndex = tabIndexByNavStrategy[(props === null || props === void 0 ? void 0 : props.navStrategy) || "arrowsHandled"];
  return /* @__PURE__ */ import_react.default.createElement(import_WithTooltip.WithTooltip, props === null || props === void 0 ? void 0 : props.tooltip, /* @__PURE__ */ import_react.default.createElement(import_LinkTab.StyledLinkTab, {
    "data-testid": "".concat(props.id, "-test-tab"),
    "aria-current": selected,
    "aria-controls": props.id,
    id: props.id,
    ref: linkTabRef,
    isDisabled: props.isDisabled,
    "aria-disabled": props.isDisabled,
    role: "link",
    selected,
    href: !props.isDisabled ? props.href : null,
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    onClick,
    tabIndex,
    fontSize: props.fontSize,
    isBold: props.isBold,
    customStyle: props.customStyle
  }, /* @__PURE__ */ import_react.default.createElement(import_Tab.StyledContentContainer, null, (_props$title = props.title) === null || _props$title === void 0 ? void 0 : _props$title.trim())));
};
LinkTab.displayName = "LinkTab";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  LinkTab
});
//# sourceMappingURL=LinkTab.component.js.map